import localeText from "../../../../../../locale";
import SecurityValidationOtpInput from "./SecurityValidationOtpInput";

const SecurityValidationBody = ({
  email,
  amountLabel,
  recipientName,
  code,
  onCodeChange,
  formattedTime,
  isExpired,
  resending,
  validating,
  onResend,
  confirmTemplateKey = "securityValidationConfirmTransfer",
  codeLength = 4,
}) => {
  const resendDisabled = !isExpired || resending || validating;
  const [beforeEmail, afterEmail] = (localeText("securityValidationEmailSent") || "")
    .replace("{length}", String(codeLength))
    .split("{email}");
  const confirmParts = (localeText(confirmTemplateKey) || "").split(
    /\{amount\}|\{recipient\}/,
  );
  const timeParts = (localeText("securityValidationCodeExpires") || "").split("{time}");

  return (
    <div className="security-validation-body">
      <p className="security-validation-email-text text-sm font-medium">
        {beforeEmail}
        <span className="font-bold">{email || ""}</span>
        {afterEmail}
      </p>

      <div className="security-validation-email-icon" aria-hidden="true">
        <span className="security-validation-orbit">
          <span className="security-validation-orbit-dot security-validation-orbit-dot--a" />
          <span className="security-validation-orbit-dot security-validation-orbit-dot--b" />
        </span>
        <span className="security-validation-email-icon-circle">
          <svg
            width="27"
            height="22"
            viewBox="0 0 27 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.4 3V1.1916C2.4022 0.876454 2.52828 0.574821 2.75102 0.351861C2.97375 0.128902 3.27526 0.00251358 3.5904 0H25.2096C25.8672 0 26.4 0.534 26.4 1.1916V20.4084C26.3978 20.7235 26.2717 21.0252 26.049 21.2481C25.8262 21.4711 25.5247 21.5975 25.2096 21.6H3.5904C3.27458 21.5997 2.9718 21.474 2.74859 21.2506C2.52538 21.0271 2.4 20.7242 2.4 20.4084V19.2H24V5.16L14.4 13.8L2.4 3ZM0 8.4H6V10.8H0V8.4ZM0 14.4H9.6V16.8H0V14.4Z"
              fill="var(--theme-primary)"
            />
          </svg>
        </span>
      </div>

      <p className="security-validation-confirm-text text-sm font-medium">
        {confirmParts[0]}
        <span className="font-bold">{amountLabel}</span>
        {confirmParts[1]}
        <span className="font-bold">{recipientName}</span>
        {confirmParts[2]}
      </p>

      <SecurityValidationOtpInput
        value={code}
        onChange={onCodeChange}
        disabled={validating || resending}
        length={codeLength}
      />

      <p className="security-validation-timer text-sm font-medium">
        {timeParts[0]}
        <span className="font-bold">{formattedTime}</span>
        {timeParts[1]}
      </p>

      <button
        type="button"
        className="security-validation-resend text-sm font-semibold"
        onClick={onResend}
        disabled={resendDisabled}
      >
        {isExpired
          ? localeText("securityValidationResend")
          : localeText("securityValidationResendIn")}
      </button>
    </div>
  );
};

export default SecurityValidationBody;
